import React from 'react';
import HomeLogo from 'assets/images/Home/Icono_home.svg';
import PropTypes from 'prop-types';
import './HeaderPage.scss';

const HeaderPage = ({ section, section2, title, header }) => {
  return (
    <div className="container-headerPage">
      <div>
        <img className="home-svg" src={HomeLogo} alt="" /> |{' '}
        <span style={{ color: '#AAAAAA', fontSize: '13px' }}>{section}</span>{' '}
        {section !== '' ? `${'| '}` : ' '}
        {section2 ? (
          <span style={{ color: '#c12b7d', fontSize: '13px' }}>{section2}</span>
        ) : (
          <span style={{ color: '#c12b7d', fontSize: '13px' }}>{title}</span>
        )}
      </div>
      {title && <h1 className="title-label">{title}</h1>}
      <span className="header-label">{header}</span>
    </div>
  );
};

HeaderPage.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  section: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  section2: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

HeaderPage.defaultProps = {
  title: '',
  header: '',
  section: '',
  section2: null
};

export default HeaderPage;
